import React, {useContext} from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import ExpansionPanelTitleAvatar from "components/ExpansionPanelTitleAvatar";
import {getSectionVariant} from "../../../../constants/StageSections";
import SignatureIcon from "components/icon/SignatureIcon";
import Button from "components/Button";
import {OfferStatusType} from "../../../common/constants/OfferStatusType";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from '@material-ui/icons/Delete';
import {makeStyles} from "@material-ui/styles";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import {useParams} from "react-router";
import useLoadingScreen from "hooks/useLoadingScreen";
import DemandOffersService from "services/DemandOffersService";
import isResponseValid from "libs/isResponseValid";
import {ContractorPasswordState} from "constants/ContractorPasswordState";
import useSignature from "hooks/useSignature";
import {simpleAlert} from "libs/AlertNotification";
import {simpleConfirmNoTranslate} from "libs/ConfirmNotification";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import OfferStageTranslationsContext from "context/OfferStageTranslationsContext";
import SupportModeContext from "context/SupportModeContext";

const useStyle = makeStyles(theme => ({
    marginRight: {
        marginRight: theme.spacing(2)
    },
    offerDate: {
        marginLeft: theme.spacing(4),
        fontStyle: "italic"
    }
}))


function OfferEditSectionTitle(
    {
        section,
        expanded
    }) {
    const classes = useStyle();
    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const supportMode = useContext(SupportModeContext);
    const stageTr = useContext(OfferStageTranslationsContext);
    const {hideLoadingScreen, showLoadingScreen} = useLoadingScreen();
    const {doSignDocContent, breakSigning} = useSignature();
    const stopSigningOperation = (e) => {
        e.stopPropagation();
        simpleConfirmNoTranslate(stageTr("sign_offer_form_stop_confirm"), () => {
                showLoadingScreen();
                DemandOffersOfferService.stopSigningOperation(demandId, stageId).finally(hideLoadingScreen);
            }
        )
    }
    const deleteOffer = (e) => {
        e.stopPropagation();
        simpleConfirmNoTranslate(stageTr("delete_offer_confirm"), () => {
                showLoadingScreen();
                DemandOffersOfferService.deleteOffer(demandId, stageId, undefined, stageTr).finally(hideLoadingScreen);
            }
        )
    }

    const signPlaceOffer = (e) => {
        e.stopPropagation();

        (async () => {
            try {
                const passResp = await DemandOffersService.getPasswordStatus(demandId, stageId);
                if (isResponseValid((passResp))) {
                    if (passResp.result.state === ContractorPasswordState.HAS_PASSWORD_STORED) {
                        signOffer();
                    } else {
                        DemandOffersService.openContractorPasswordPopup(() => signOffer, () => null)
                    }
                }
            } catch (e) {
                console.error(e);
            }
            hideLoadingScreen();
        })();

    }

    const signOffer = () => {
        doSignDocContent(
            section.signatureTypes,
            async (sigType) => {
                const result = await DemandOffersOfferService.getDocumentToSign(demandId, stageId, {positionIds: null, signatureType: sigType});
                if (!result)
                    breakSigning();
                return result;

            },
            (signatureType, signature, signatureFileId) => {
                breakSigning();
                showLoadingScreen();
                DemandOffersOfferService.signOffer(demandId, stageId, {
                    positionIds: null,
                    signatureType,
                    signature,
                    signatureFileId
                }, section.onePositionMode, stageTr)
                    .finally(hideLoadingScreen)
            },
            (error) => {
                console.error(error)
                simpleAlert("signature_error");
                breakSigning();
            },
            () => {
                breakSigning();
            },
            async () => section.roundId
        )
    }

    return (
        <GridBlock alignItems="center" justify="space-between">
            <GridBlock alignItems="center">
                <ExpansionPanelTitleAvatar variant={getSectionVariant(section)}/>
                <Typography variant='h6'>
                    {section.name}
                </Typography>
                {!!section.offerTmpDate &&
                    <Typography className={classes.offerDate}>
                        {stageTr("offer_tmp_date")}: {moment(section.offerTmpDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}
                    </Typography>
                }
            </GridBlock>

            {
                (!purchaserOfferContext && section.contractorOfferStatus === OfferStatusType.NORMAL && section.offerDate === null && section.offerTmpDate !== null && section.editable) &&
                <Button Icon={DeleteIcon} onClick={deleteOffer} variant='outlined' disabled={supportMode}>{stageTr("delete_offer")}</Button>
            }

            {(!expanded && section.contractorOfferStatus === OfferStatusType.WAITING_SIGNATURE) &&
                <div>
                    <Button Icon={CancelIcon} onClick={stopSigningOperation} variant='outlined' disabled={supportMode}
                            className={classes.marginRight}>{stageTr("sign_offer_form_stop")}</Button>
                    <Button Icon={SignatureIcon} onClick={signPlaceOffer} disabled={supportMode}>{stageTr("sign_offer_form")}</Button>
                </div>
            }
        </GridBlock>
    )

}

OfferEditSectionTitle.propTypes = {
    expanded: PropTypes.bool.isRequired,
    section: PropTypes.shape({
        section: PropTypes.string.isRequired
    }).isRequired
}

export default OfferEditSectionTitle;